import { IQtyAdjustmentHistoryFilterState, IQtyAdjustmentHistoryListRequestBody } from 'x/types'

/**
 * Default filter state สำหรับ QtyAdjustmentHistoryList
 */
export const DEFAULT_QTY_ADJUSTMENT_HISTORY_FILTER: IQtyAdjustmentHistoryFilterState = {
  searchText: '',
  selectedMode: null,
  isDateRangeEnabled: false,
  dateRangeFrom: undefined,
  dateRangeTo: undefined,
  selectedOptionKey: 'Today',
}

/**
 * แปลง filter state เป็น request body สำหรับ API call
 * @param filter - filter state ปัจจุบัน
 * @param storeId - store_id
 * @param pp_ids - pp_ids (optional)
 * @param offset - offset สำหรับ pagination
 * @param limit - limit สำหรับ pagination
 * @returns IQtyAdjustmentHistoryListRequestBody
 */
export const convertFilterToRequestBody = (
  filter: IQtyAdjustmentHistoryFilterState,
  storeId: number,
  pp_ids?: number[],
  offset = 0,
  limit = 20
): IQtyAdjustmentHistoryListRequestBody => {
  const reqBody: IQtyAdjustmentHistoryListRequestBody = {
    store_id: storeId,
    offset,
    limit,
  }

  // Add search text
  if (filter.searchText && filter.searchText.trim().length > 0) {
    reqBody.search_text = filter.searchText.trim()
  }

  // Add pp_ids
  if (pp_ids && pp_ids.length > 0) {
    reqBody.pp_ids = pp_ids
  }

  // Add date range (only if enabled)
  if (filter.isDateRangeEnabled) {
    if (filter.dateRangeFrom) {
      reqBody.created_at_from = filter.dateRangeFrom
    }

    if (filter.dateRangeTo) {
      reqBody.created_at_to = filter.dateRangeTo
    }
  }

  // Add mode filter
  if (filter.selectedMode) {
    reqBody.mode = filter.selectedMode
  }

  return reqBody
}

/**
 * Merge filter กับ default filter
 * @param filter - filter ที่ต้องการ merge
 * @param defaultFilter - default filter
 * @returns merged filter
 */
export const mergeWithDefaultFilter = (
  filter?: Partial<IQtyAdjustmentHistoryFilterState>,
  defaultFilter: IQtyAdjustmentHistoryFilterState = DEFAULT_QTY_ADJUSTMENT_HISTORY_FILTER
): IQtyAdjustmentHistoryFilterState => ({
  ...defaultFilter,
  ...filter,
})

/**
 * ตรวจสอบว่ามี filter ที่แตกต่างจาก default หรือไม่
 * @param currentFilter - filter ปัจจุบัน
 * @param defaultFilter - default filter
 * @returns true ถ้ามี filter ที่แตกต่างจาก default
 */
export const isFilterDifferentFromDefault = (
  currentFilter: IQtyAdjustmentHistoryFilterState,
  defaultFilter: IQtyAdjustmentHistoryFilterState = DEFAULT_QTY_ADJUSTMENT_HISTORY_FILTER
): boolean => {
  // Check search text
  const currentSearchText = currentFilter.searchText?.trim() || ''
  const defaultSearchText = defaultFilter.searchText?.trim() || ''
  if (currentSearchText !== defaultSearchText) {
    return true
  }

  // Check mode
  if (currentFilter.selectedMode !== defaultFilter.selectedMode) {
    return true
  }

  // Check date range enabled
  if (currentFilter.isDateRangeEnabled !== defaultFilter.isDateRangeEnabled) {
    return true
  }

  // If date range is enabled, check date values
  if (currentFilter.isDateRangeEnabled) {
    if (currentFilter.dateRangeFrom !== defaultFilter.dateRangeFrom) {
      return true
    }
    if (currentFilter.dateRangeTo !== defaultFilter.dateRangeTo) {
      return true
    }
    if (currentFilter.selectedOptionKey !== defaultFilter.selectedOptionKey) {
      return true
    }
  }

  return false
}
